import React, { useState, useEffect } from "react";
const Videos = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetch("https://kvrstarlightmedicalacademy.com/api/videos.php")
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);
  const videos = [];
  data?.map((element) => {
    videos.push(element.url);
  });
  return (
    <div style={{ padding: "20px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "20px",
        }}
      >
        {videos.map((link, index) => (
          <iframe
            key={index}
            width="360"
            height="215"
            src={link}
            title={`Video ${index + 1}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        ))}
      </div>
    </div>
  );
};

export default Videos;
